// removed by extract-text-webpack-plugin
module.exports = {"spinner__absolute":"Spinner-module__spinner__absolute___1Maxf","loader__circular":"Spinner-module__loader__circular___2OEb7","rotate":"Spinner-module__rotate___AS7kY","loader__small":"Spinner-module__loader__small___1H1G-","loader__path":"Spinner-module__loader__path___10Ibf","dash":"Spinner-module__dash___3pqmM","color":"Spinner-module__color___1qN3P","loader__singleColor":"Spinner-module__loader__singleColor___nNZkj"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/UI/Spinner/Spinner.module.css
// module id = 652
// module chunks = 0